import React from "react";
import './fpComp.scss';
import {useHistory} from "react-router";


function FailureMessage (props:any) {
    const history = useHistory();

    return (
        <div className="failureMessage w-full" >
            <div className="title">Something Went Wrong</div>
            <div className="subTitle" style={{marginTop:"16px"}}>Hold tight while we resolve the error. In the meantime, feel free to refresh the page or attempt again later.</div>
            <div style={{marginTop: "40px"}} >
                <button onClick={() => history.push('/forgotPassword')} className='submitBtn' >Try Again</button>
            </div>
            <div style={{marginTop: "20px"}} >
                <button onClick={() => history.goBack()} className='goBackBtn' >Go Back</button>
            </div>
        </div>
    )
}

export default FailureMessage;